<template>
  <div :class="bem.b()">
    <RadioGroup v-model:value="type">
      <div :class="bem.m('item')">
        <Radio :value="TypeEnum.every" v-bind="beforeRadioAttrs"> 每年 </Radio>
      </div>
      <div :class="bem.m('item')">
        <Radio :value="TypeEnum.range" v-bind="beforeRadioAttrs"> 区间 </Radio>
        <span>从</span>
        <InputNumber
          v-model:value="valueRange.start"
          :class="bem.e('w100')"
          v-bind="typeRangeAttrs"
        />
        <span>年 至</span>
        <InputNumber
          v-model:value="valueRange.end"
          :class="bem.e('w100')"
          v-bind="typeRangeAttrs"
        />
        <span>年</span>
      </div>
      <div :class="[bem.m('item'), bem.is('year')]">
        <Radio :value="TypeEnum.loop" v-bind="beforeRadioAttrs">循环</Radio>
        <span>从</span>
        <InputNumber
          v-model:value="valueLoop.start"
          :class="bem.e('w100')"
          v-bind="typeLoopAttrs"
        />
        <span>年开始，间隔</span>
        <InputNumber
          v-model:value="valueLoop.interval"
          :class="bem.e('w100')"
          v-bind="typeLoopAttrs"
        />
        <span>年</span>
      </div>
    </RadioGroup>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { InputNumber, RadioGroup, Radio } from 'ant-design-vue'
import {
  useTabProps,
  useTabEmits,
  useTabSetup
} from '../../config/use-tab-mixin'
export default defineComponent({
  name: 'YearUI',
  components: { InputNumber, RadioGroup, Radio },
  props: useTabProps({
    defaultValue: '*'
  }),
  emits: useTabEmits(),
  setup(props, context) {
    const nowYear = new Date().getFullYear()

    return useTabSetup(props, context, {
      defaultValue: '*',
      minValue: 0,
      valueRange: { start: nowYear, end: nowYear + 100 },
      valueLoop: { start: nowYear, interval: 1 }
    })
  }
})
</script>
